import type { Metric } from 'web-vitals';

import { isBotUserAgent } from '~/utils/isBotUserAgent';
import { toWebVitalReport } from '~/utils/webVitalReport';
import { useDatadog } from '~~/composables/useDatadog';

export default defineNuxtPlugin({
	name: 'web-vitals',
	setup() {
		if (import.meta.env.VITEST || import.meta.env.MODE === 'test') {
			return;
		}

		if (isBotUserAgent()) {
			return;
		}

		const init = async () => {
			try {
				const { onCLS, onFCP, onINP, onLCP, onTTFB } =
					await import('web-vitals');
				const { trackWebVital } = useDatadog();

				const report = (metric: Metric) =>
					trackWebVital(toWebVitalReport(metric, window.location.href));

				onCLS(report);
				onFCP(report);
				onINP(report);
				onLCP(report);
				onTTFB(report);
			} catch (error) {
				console.error('Failed to initialize Web Vitals:', error);
			}
		};

		if (typeof window !== 'undefined') {
			if ('requestIdleCallback' in window) {
				requestIdleCallback(() => init(), { timeout: 5000 });
			} else {
				setTimeout(init, 2000);
			}
		}
	}
});
